<template>
  <section class="tab--b-card" :class="isAdmin ? '' : 'body--detail--chat-list'">
    <div class="body--detail-chat-container" >
      <div v-for="(message, index) in arrayMessages" :key="index" >
        <body-detail-message :message="message" :index="index" :ticket_id="ticket.delivery.id" @updateTicket="$emit('updateTicket', true)" :isTheModal="isTheModal" :companyData="company" :masterData="masterData" :ticket="ticket"></body-detail-message>
      </div>
    </div>
  </section>
</template>
<script>
import BodyDetailMessage from '@/views/modules/tickets/components/Detail/Message/BodyDetailMessage.vue'
import BaseServices from '@/store/services/index'
export default {
  props: ['messages', 'ticket', 'isTheModal', 'masterData'],
  components: {BodyDetailMessage},
  data() {
    return {
      baseService: new BaseServices(this),
      company: {
        logoUrl: '',
        logoVerify: '',
        name: ''
      }
    }
  },
  computed: {
    dataUser() {
      return this.$session.get('cas_user')
    },
    arrayMessages() {
      return this.messages.map(el => {
        return {...el, logo: {...this.company}}
      }) || []
    },
    isAdmin() {
      return this.dataUser?.role === 'admin'
    }
  },
  mounted() {
    this.searchShippers()
  },
  methods: {
    searchShippers() {
      this.loading = true
      const params = {
        company_id: this.ticket?.company?.id
      }
      const queryParams = {
        // name_sub_string: this.ticket?.company?.name
      }
      return this.baseService.callService('getCompanyInformation', queryParams, params)
        .then(response => {
          this.company = this.setLogoData(response?.data?.company)
        })
        .catch(err => {
          console.error(err)
        })
    },
    setLogoData(company) {
      return {
        logoUrl: company?.logo_url || '',
        logoUrl2: company?.logo_url_v2 || '',
        logoVerify: company?.logo_verify ? `https://storage.googleapis.com/easypoint-images/${company?.logo_verify}` : '',
        name: company?.name1 || ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .body--detail--chat-list {
    max-height: 320px;
    overflow-y: scroll;
  }
  .body--detail-chat-container {
    display: grid;
    gap: 20px;
  }
</style>

